import DashboardIcon from '@/components/icons/sidebar/DashboardIcon';
import CarIcon from '@/components/icons/sidebar/CarIcon';
import MaintenanceIcon from '@/components/icons/sidebar/MaintanceIcon';
import DocumentLinesIcon from '@/components/icons/sidebar/DocumentLinesIcon';
import FileIcon from '@/components/icons/sidebar/FileIcon';
import MessagesIcon from '@/components/icons/sidebar/messages';
import SupportIcon from '@/components/icons/sidebar/ChatIcon';
import ChartIcon from '@/components/icons/sidebar/ChartIcon';
import UsersIcon from '@/components/icons/sidebar/UsersIcon';
import LocationIcon from '@/components/icons/sidebar/LocationIcon';
import TwoUsersIcon from '@/components/icons/sidebar/TwoUsersIcon';
import UserEditIcon from '@/components/icons/sidebar/UserEditIcon';

export const navigationBottom = [
    { name: 'messages', icon: MessagesIcon, activeIcon: MessagesIcon, to: '' },
    { name: 'settings', icon: MaintenanceIcon, activeIcon: MaintenanceIcon, to: '' },
    { name: 'help_and_support', icon: SupportIcon, activeIcon: SupportIcon, to: '' },
];

export const carsNavigation = [
    { name: 'cars_list', to: '/cars/list' },
    // { name: 'cars_tracking', to: '/coming-soon' },
    // { name: 'cars_performance', to: '/coming-soon' },
    { name: 'bookings', to: '/cars/booking' },
    // { name: 'available_cars', to: '/cars/available-cars' },
    { name: 'reservations', to: '/cars/reservations' },
    { name: 'booking_archive', to: '/cars/booking-archive' },
    // { name: 'contracts', to: '/cars/contracts' },
    { name: 'contracts_archive', to: '/cars/contract-archive' },
];

export const branchesNavigation = [
    { name: 'branches_list', to: '/branches/list' },
    { name: 'add_branch', to: '/branches/add' },
];

export const carsContracts = [
    { name: 'available_cars', to: '/booking/available-cars' },
    { name: 'reservations', to: '/booking/reservations' },
    { name: 'booking_archive', to: '/booking/booking-archive' },
    { name: 'contracts', to: '/booking/contracts' },
    { name: 'contracts_archive', to: '/booking/contract-archive' },
];

export const carsMaintenance = [
    { name: 'maintenance_list', to: '/maintenance/list' },
    { name: 'maintenance_center', to: '/maintenance/centers' },
];

export const carsInvoices = [
    { name: 'returns', to: '/invoicing/returns' },
    { name: 'creditors', to: '/invoicing/creditors' },
    { name: 'Store_permissions', to: '/invoicing/store-permissions' },
];

export const financialManagement = [
    { name: 'financial_center_list', to: '/coming-soon' },
    { name: 'financial_reports', to: '/coming-soon' },
];

export const humanResources = [
    { name: 'attendance_and_departure', to: '/human-resources/departure' },
    // { name: 'entry_exit', to: '/human-resources/entry-exit' },
    { name: 'salaries', to: '/human-resources/salaries' },
    { name: 'employees', to: '/human-resources/employees' },
    { name: 'employees_reviews', to: '/human-resources/employees-reviews' },
    { name: 'contract_management', to: '/human-resources/contract-management' },
    { name: 'shifts', to: '/human-resources/shifts' },
    { name: 'hr_self_services', to: '/human-resources/self-services' },
    { name: 'departments', to: '/human-resources/departments' },
    { name: 'trainees', to: '/human-resources/trainees' },
    { name: 'السلف والقروض', to: '/human-resources/personal-loans' },
    { name: 'الخصومات والبدلات', to: '/human-resources/deductions' },
    { name: 'tasks', to: '/human-resources/tasks' },


];
export const selfServices = [
    { name: 'holidays_requests', to: '/self-services/holidays-requests' },
    { name: 'insurances', to: '/self-services/insurance' },
    { name: 'loans', to: '/self-services/loans' },
    { name: 'finances', to: '/finances' },
    { name: 'services', to: '/self-services/services' },
];

export const accessControlNavigation = [
    { name: 'access_control_roles', to: '/access-control/roles' },
    { name: 'access_control_permissions', to: '/access-control/permissions' },
    { name: 'access_control_user_roles', to: '/access-control/user-roles' },
];

export const careerPath = [
    // { name: 'career_path', to: '/career-path' },
    { name: 'job', to: '/career-path/job' },
    { name: 'interviews', to: '/career-path/interviews' },
    { name: 'applicants', to: '/career-path/applicants' },
];
export const customerRelations = [
    { name: 'customer_communication', to: '/customer-relations/customer-communication' },
    { name: 'complaints', to: '/customer-relations/complaints' },
    { name: 'marketing', to: '/customer-relations/marketing' },
];

export const navigation = [
    { name: 'dashboard', icon: DashboardIcon, activeIcon: DashboardIcon, to: '/' },
    { name: 'cars', icon: CarIcon, activeIcon: CarIcon, to: '/cars', navigation: carsNavigation },
    {
        name: 'branches',
        icon: LocationIcon,
        activeIcon: LocationIcon,
        to: '/branches',
        navigation: branchesNavigation,
    },
    {
        name: 'customer_relations',
        icon: TwoUsersIcon,
        activeIcon: TwoUsersIcon,
        to: '/customer-relations',
        navigation: customerRelations,
    },
    // {
    //     name: 'booking_calendar',
    //     icon: DocumentLinesIcon,
    //     activeIcon: DocumentLinesIcon,
    //     to: '/booking-calendar',
    // },
    // { name: 'bookings', icon: FileIcon, activeIcon: FileIcon, to: '/booking', navigation: carsContracts },
    {
        name: 'maintenance',
        icon: MaintenanceIcon,
        activeIcon: MaintenanceIcon,
        to: '/maintenance',
        navigation: carsMaintenance,
    },
    {
        name: 'invoices_and_collection',
        icon: DocumentLinesIcon,
        activeIcon: DocumentLinesIcon,
        to: '/invoicing',
        navigation: carsInvoices,
    },
    {
        name: 'financial_management',
        icon: ChartIcon,
        activeIcon: ChartIcon,
        to: '/coming-soon',
        navigation: financialManagement,
    },
    {
        name: 'human_resources',
        icon: UsersIcon,
        activeIcon: UsersIcon,
        to: '/human-resources',
        navigation: humanResources,
    },
    {
        name: 'self_services',
        icon: UserEditIcon,
        activeIcon: UserEditIcon,
        to: '/self-services',
        navigation: selfServices,
    },
    {
        name: 'career_path',
        icon: UsersIcon,
        activeIcon: UsersIcon,
        to: '/career-path',
        navigation: careerPath,
    },
    {
        name: 'access_control',
        icon: DocumentLinesIcon,
        activeIcon: DocumentLinesIcon,
        to: '/access-control',
        navigation: accessControlNavigation,
    },
];
